import React from "react";
import { useTranslation } from "react-i18next";
import { INTEGRATION_CHECKS, INTEGRATION_STEPS } from "../landingData";

const LandingIntegration = () => {
  const { t } = useTranslation("common");

  return (
    <section className="integration" id="integration">
      <div className="integration-card">
        <div className="integration-left">
          <div className="badge-aws">{t("AWS Integration")}</div>
          <h2>
            {(() => {
              const heading = t("Connect Any Odoo, Anywhere");
              const [first, second] = heading.split(", ");
              return (
                <>
                  {first},
                  <br />
                  {second || ""}
                </>
              );
            })()}
          </h2>
          <p>
            {t(
              "Whether your Odoo runs on SH, Enterprise cloud, or a local server — our AWS integration layer creates a secure, high-performance tunnel to your data."
            )}
          </p>
          <ul className="check-list">
            {INTEGRATION_CHECKS.map((item) => (
              <li key={item}>
                <span className="check">✓</span> {t(item)}
              </li>
            ))}
          </ul>
        </div>
        <div className="integration-right">
          {INTEGRATION_STEPS.map(({ num, titleKey, descriptionKey }) => (
            <div key={num} className="step-card">
              <span className="step-num">{num}</span>
              <div>
                <strong>{t(titleKey)}</strong>
                <p>{t(descriptionKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingIntegration;
